import { lazy } from 'react';
import { ROUTE_ADMIN, ROUTE_AUTO_LOGIN, ROUTE_CONTACT, ROUTE_COOKIES, ROUTE_HOME, ROUTE_IMPRINT, ROUTE_PRIVACYPOLICY, ROUTE_REGISTER, ROUTE_STORE } from 'src/config/routes';
import { ROUTE_ACCOUNT } from 'src/config/account-routes';
import { RouteDescriptor } from '../SiteDefinition';

const AdminPanelHomeRoutes = lazy(() => import('src/adminPanel/components/pages/AdminPanelHomeRoutes'));
const Contact = lazy(() => import('src/pages/Contact'));
const RegisterRoutes = lazy(() => import('src/pages/register/RegisterRoutes'));
const AccountRoutes = lazy(() => import('src/pages/account/AccountRoutes'));
const StoreRoutes = lazy(() => import('src/pages/store/StoreRoutes'));
const Imprint = lazy(() => import('src/pages/Imprint'));
const PrivacyPolicy = lazy(() => import('src/pages/PrivacyPolicy'));
const Cookies = lazy(() => import('src/pages/Cookies'));
const AutoLogin = lazy(() => import('src/pages/AutoLogin'));
const Home = lazy(() => import('src/pages/Home'));

export const coreSiteRoutes: RouteDescriptor[] = [
    {
        key: 'admin-panel',
        route: ROUTE_ADMIN,
        component: AdminPanelHomeRoutes,
    },
    {
        key: 'contact',
        route: ROUTE_CONTACT,
        component: Contact,
    },
    {
        key: 'register',
        route: ROUTE_REGISTER,
        component: RegisterRoutes,
    },
    {
        key: 'account',
        route: ROUTE_ACCOUNT,
        component: AccountRoutes,
    },
    {
        key: 'store',
        route: ROUTE_STORE,
        component: StoreRoutes,
    },
    {
        key: 'imprint',
        route: ROUTE_IMPRINT,
        component: Imprint,
    },
    {
        key: 'privacy',
        route: ROUTE_PRIVACYPOLICY,
        component: PrivacyPolicy,
    },
    {
        key: 'cookies',
        route: ROUTE_COOKIES,
        component: Cookies,
    },
    {
        key: 'auto-login',
        route: ROUTE_AUTO_LOGIN,
        component: AutoLogin,
    },
    {
        key: 'home',
        route: ROUTE_HOME,
        component: Home,
    }
];
